import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b261e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-account-layout" }

import AuthorizedLayout from '@/layouts/AuthorizedLayout.vue';
import BaseBox from '@/components/layout/BaseBox.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { NDescriptions, NDescriptionsItem } from 'naive-ui';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import ChangeMyPasswordForm from '@/forms/ChangeMyPasswordForm.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getters } = useStore();
const userInfo = computed<AuthUser>(() => getters['auth/userInfo']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthorizedLayout, { title: "Můj účet" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseFlex, {
          row: "",
          "row-gap": "15px",
          "col-gap": "15px",
          wrap: "wrap"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFlex, {
              col: "",
              "class-name": "basic-info"
            }, {
              default: _withCtx(() => [
                _createVNode(BaseBox, { title: "Základní informace" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "top",
                      column: 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "Jméno" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(userInfo).first_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "Příjmení" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(userInfo).last_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "Email/uživatelské jméno" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(userInfo).username), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(BaseFlex, {
              col: "",
              class: "change-password"
            }, {
              default: _withCtx(() => [
                _createVNode(BaseBox, { title: "Změna hesla" }, {
                  default: _withCtx(() => [
                    _createVNode(ChangeMyPasswordForm)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})